import NoteComment from "@/entities/NoteComment";
import FileData from "@/entities/FileData";

export default class Note {
    constructor(data) {
        this.id = data.id;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
        this.path = data.path;
        this.title = data.title;
        this.content = data.content;
        this.comments = data.comments ? data.comments.map(x => new NoteComment(x)) : [];
        this.tags = data.tags;
        this.fileIds = data.fileIds ? data.fileIds.map(x => new FileData(x)) : [];
    }
}